"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var commonweb_utils_1 = require("commonweb-utils");
/**
 * Fetches additional FPTI variable for views. Contains mapping of view to function.
 * Function should return additional fpti variables for those views.
 * @returns additional FPTI vairbale
 */
function getFptiValueforBillingAddressManagement(state) {
    var addresses = commonweb_utils_1.objectUtils.safeGet(state, "account.addressData.addresses") || [], route = state.route, addressToProcess = addresses.find(function (addr) { return addr.id === route.enter.params.id; }), fptiValue;
    if (addressToProcess) {
        if (addressToProcess.cardList) {
            if (addressToProcess.cardList.length === 1 && addressToProcess.isCardAddressUpdatable) {
                fptiValue = "billingAddressUpdatable";
            }
            else if (addressToProcess.cardList.length > 1) {
                fptiValue = "billingAddressNotUpdatableMultipleCard";
            }
            else {
                fptiValue = "billingAddressNotUpdatableSingleCard";
            }
        }
        return {
            error_desc: fptiValue
        };
    }
    return {};
}
exports.default = {
    'update-billing-address': getFptiValueforBillingAddressManagement,
    'delete-billing-address': getFptiValueforBillingAddressManagement
};
